module.exports = __webpack_public_path__ + "static/grandmaster-d53b4f8ef66cf041568ce10d73f16a9c.png";